module.exports = __webpack_public_path__ + "static/logo-white-be49731efc20e14a9665fb23daf88052.svg";